import {
  IGeometryModel,
  MarkerModelBase,
} from '@types-custom/models/business/marker.model';
import { Icon } from '@types-custom/models/ui/icon-model';

export interface IPropsCameraPointModel {
  id: string;
  icon: Icon;
  address: string;
  name: string;
  markerPopupText?: string;
  url:string;
  status:string;
  cameraType:string;
  description:string;
}

export interface ICameraPointModalModel {
  icon: Icon;
  alt: string;
  id: string;
  title: string;
}

export class CameraPointsModel extends MarkerModelBase {
  static className = 'CameraPointsModel';

  classProperties: IPropsCameraPointModel;

  constructor(props: IPropsCameraPointModel, geometry: IGeometryModel) {
    super(geometry, CameraPointsModel.className);
    this.classProperties = props;
  }
}

export interface ICameraModel {
  id: number;
  name: string;
  address: string;
  description: string;
  localityName: string;
  neighborhoodName: string;
  statusName: string;
  cameraTypeName: string;
};

